import type { ReactNode } from 'react';

import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts';

import type { NavItemConfig } from '../../types';

export const getMenuIconAndLabel =
	(items: Record<string, NavItemConfig>, shortcuts: Record<string, GlobalShortcutsItem>) =>
	(menuId: string): { icon: ReactNode; label: string } => {
		const item = items[menuId];

		if (item) {
			const { elemBefore: icon, label } = item;
			return { icon, label };
		}

		const shortcut = shortcuts[menuId];

		if (shortcut) {
			const { icon, label } = shortcut;
			return { icon, label };
		}

		throw Error(`Menu id ${menuId} not found in either items or shortcuts`);
	};
